import { cn } from "@/lib/utils";
import { TRADE_LOG_FILTER_INPUT_CLASS } from "@/components/trade-filter-selects";

export const POLICY_TREE_SUBTLE_TEXT_CLASS =
  "font-[family-name:var(--font-primary)] text-gray-500 dark:text-white";

export const POLICY_TREE_GROUP_TITLE_CLASS =
  "truncate font-[family-name:var(--font-primary)] text-sm font-semibold text-[color:var(--brand-tropical-surf)]";

export const POLICY_TREE_RULE_TITLE_CLASS =
  "truncate font-[family-name:var(--font-primary)] text-sm font-semibold text-[#F4B400]";

export const POLICY_TREE_FIELD_LABEL_CLASS =
  "font-[family-name:var(--font-primary)] text-xs text-gray-500 dark:text-white";

export const POLICY_TREE_HELPER_TEXT_CLASS =
  "mt-2 w-full font-[family-name:var(--font-primary)] text-xs leading-snug text-gray-500 dark:text-white";

export const POLICY_TREE_INPUT_CLASS = cn(
  TRADE_LOG_FILTER_INPUT_CLASS,
  "h-8 min-h-8 text-xs font-[family-name:var(--font-primary)] font-medium",
);

export const POLICY_TREE_SEGMENT_CARD_CLASS = cn(
  "rounded-xl border border-solid border-border bg-card p-4 shadow-none ring-0",
  "dark:border-border dark:bg-[color-mix(in_oklab,var(--sidebar)_88%,black)]",
);

export const POLICY_TREE_SEGMENT_TITLE_CLASS =
  "font-[family-name:var(--font-primary)] text-sm font-semibold text-[color:var(--brand-tropical-surf)]";

export const POLICY_TREE_SEGMENT_SUBTITLE_CLASS =
  "font-[family-name:var(--font-primary)] text-xs text-gray-500 dark:text-white";

export const POLICY_TREE_EMPTY_TEXT_CLASS =
  "font-[family-name:var(--font-primary)] text-sm text-gray-500 dark:text-white";

export const POLICY_TREE_ERROR_TEXT_CLASS =
  "font-[family-name:var(--font-primary)] text-sm text-red-500";

export type PolicyGraphChrome = {
  canvasBg: string;
  groupNodeBg: string;
  ruleNodeBg: string;
  border: string;
  text: string;
  subtle: string;
  edgeStroke: string;
  gridColor: string;
};

/** React Flow node chrome — follows next-themes (not Chakra colorMode). */
export function getPolicyGraphChrome(isDark: boolean): PolicyGraphChrome {
  if (isDark) {
    return {
      canvasBg: "var(--sidebar)",
      groupNodeBg: "color-mix(in oklab, var(--sidebar) 84%, black)",
      ruleNodeBg: "color-mix(in oklab, var(--sidebar) 92%, black)",
      border: "var(--border)",
      text: "#ffffff",
      subtle: "var(--sidebar-muted-foreground)",
      edgeStroke: "var(--sidebar-muted-foreground)",
      gridColor: "var(--border)",
    };
  }

  return {
    canvasBg: "#ffffff",
    groupNodeBg: "#ffffff",
    ruleNodeBg: "#F7FAFC",
    border: "#CBD5E0",
    text: "#1A202C",
    subtle: "#4A5568",
    edgeStroke: "#4A5568",
    gridColor: "#E2E8F0",
  };
}
